import React, { createContext, useState } from 'react';

export const Context = createContext(0);

const ContextProvider = ({children}) => {

    const [ flag, setFlag ] = useState(false);
    const [ bankSelected, setBankSelected ] = useState(null);
    const [ tabSwitching, setTabSwitching ] = useState(false);
    const [userName, setUserName] = useState('');
    const [userPoliciesCtx, setUserPoliciesCtx] = useState([]);        
    const [selectedPolicyIdCtx, setSelectedPolicyIdCtx] = useState(null);

    return (
      <Context.Provider
        value={{
          flag,
          setFlag,
          bankSelected,
          setBankSelected,
          tabSwitching,
          setTabSwitching,
          userName,
          setUserName,
          userPoliciesCtx,
          setUserPoliciesCtx,
          selectedPolicyIdCtx,
          setSelectedPolicyIdCtx,
        }}
      >
        {children}
      </Context.Provider>
    );
}

export default ContextProvider;

